import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MngIconComponent } from './shared/icon/icon.component';
import { AuthService } from './auth.service';

@Component({
  selector: 'mng-home',
  imports: [RouterLink, MngIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  host: { class: 'screen mng-forms' },
})
export class HomeComponent {
  protected readonly auth = inject(AuthService);
}
